import { render } from "./IconGithub.vue?vue&type=template&id=5be06126"
import script from "./IconGithub.vue?vue&type=script&lang=js"
export * from "./IconGithub.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__